module.exports = __webpack_public_path__ + "img/3.d7b32103.png";